// @ts-nocheck

import { createContext, useContext } from 'react';

type BoomModalContextProps = {
  disableScrollView: boolean;
  setDisableScrollView: (value: boolean) => void;
};

export const BoomModalContext = createContext<BoomModalContextProps>({
  disableScrollView: false,
  setDisableScrollView: () => {},
});

export const useBoomModalContext = () => useContext(BoomModalContext);
